function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-208 -3543)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(209 3511.905)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.247,35.811h-2.2V33.829a.734.734,0,0,0-.734-.734H3.67a.734.734,0,0,0-.734.734v1.982H.734A.734.734,0,0,0,0,36.544v7.192a.734.734,0,0,0,.734.734h2.2v3.868a.725.725,0,0,0,.239.6.707.707,0,0,0,.3.165,1.152,1.152,0,0,0,.319.027h10.4a1.152,1.152,0,0,0,.319-.027.707.707,0,0,0,.3-.165.726.726,0,0,0,.238-.6V44.471h2.2a.734.734,0,0,0,.734-.734V36.544A.734.734,0,0,0,17.247,35.811ZM1.835,38.4a.642.642,0,1,1,.642-.642A.642.642,0,0,1,1.835,38.4Zm12.477,10H3.67V42.6H14.311Zm0-12.587H3.67V34.563a.734.734,0,0,1,.734-.734h9.174a.734.734,0,0,1,.734.734Q14.311,35.187,14.311,35.811Z"
})), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 20,
  height: 20,
  transform: "translate(208 3543)"
}));

var SvgIcnFax = function SvgIcnFax(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_fax.63cdc901.svg";
export { ForwardRef as ReactComponent };